import { ALL_ROUTING_PROFILE_LIST } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
export const initialState = {
  routingTableData: [] as any,
  searchRoutingTableData: [] as any,
  routingProfileEnableList: [] as any,
  queueListRedux: [] as any,
};

const getAllRoutingProfileList = createSlice({
  name: ALL_ROUTING_PROFILE_LIST,
  initialState,
  reducers: {
    updateTableData: (state, { payload }) => {
      state.routingTableData = payload.routingTableData;
      state.searchRoutingTableData = payload.searchRoutingTableData;
    },
    updateQueueList: (state, { payload }) => {
      state.queueListRedux = payload.queueListRedux;
    },
    enableRoutingList: (state, { payload }) => {
      state.routingProfileEnableList = payload.routingProfileEnableList;
    },
    reset: () => {},
  },
});
export const GetAllRoutingActions = getAllRoutingProfileList.actions;
export default getAllRoutingProfileList.reducer;
